<template lang="pug">
  label.radio
    input.radio__input(
      type="radio"
      :id="id"
      :value="id"
      :name="name"
      @change="$emit('input', $event.target.value)"
      :checked="checked"
    )
    .radio__box
    slot
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'InputRadio',

    props: {
      id: {
        type: String as PropType<string>,
        required: true,
      },
      name: {
        type: String as PropType<string>,
        required: true,
      },
      checked: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
    },

    emits: ['input'],
  });
</script>

<style lang="scss" scoped>
  .radio {
    display: inline-block;
    @include fontTextBtn;
    font-weight: 400;
    padding-left: 34px;
    position: relative;
    cursor: pointer;
    user-select: none;

    @include hover {
      .radio__box {
        border-color: #2962f9;
      }
    }

    &__input {
      appearance: none;
      position: absolute;
      // polyfill
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      outline: none;

      &:checked {
        & + .radio__box {
          border-color: #2962f9;

          &:before {
            background-color: #2962f9;
          }
        }
      }
    }

    &__box {
      position: absolute;
      left: 0;
      top: 2px;
      width: 20px;
      height: 20px;
      border: 2px solid #969698;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      &:before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: transparent;
      }
    }
  }
</style>
